import theme from "assets/theme";
import React, { useEffect, useMemo, useState } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import CustomModal from "webComponentsFormElements/CustomModal.component";
import Checkbox from "webComponentsFormElements/inputs/Checkbox.component";

const classes = StyleSheet.create({
  root: {
    width: "100%",
    backgroundColor: theme.color.background,
  },
  text: {
    fontSize: 16,
    color: theme.color.backgroundText,
    marginBottom: 10,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 6,
    borderBottomWidth: 0.5,
    borderColor: theme.color.greyHighlight,
  },
  footer: {
    flexDirection: "row",
    justifyContent: "center",
    gap: 40,
    marginTop: 20,
  },
  noneText: {
    fontStyle: "italic",
    color: theme.color.backgroundText,
  },
});

export default function DismissAlertsModal({
  open,
  alerts,
  onDismiss,
  onKeep,
}) {
  const [checkedAlerts, setCheckedAlerts] = useState([]);

  useEffect(() => {
    if (open && Array.isArray(alerts) && alerts.length > 0) {
      setCheckedAlerts(alerts);
    }
  }, [open, alerts]);

  const sortedAlerts = useMemo(() => {
    return [...alerts].sort((a, b) => {
      const aChecked = checkedAlerts.some((ca) => ca.alertId === a.alertId);
      const bChecked = checkedAlerts.some((ca) => ca.alertId === b.alertId);
      if (aChecked && !bChecked) {
        return -1;
      }
      if (bChecked && !aChecked) {
        return 1;
      }
      return a.title.localeCompare(b.title);
    });
  }, [alerts, checkedAlerts]);

  const handleCheck = (alert) => {
    setCheckedAlerts((prev) => {
      const exists = prev.some((a) => a.alertId === alert.alertId);
      if (exists) {
        return prev.filter((a) => a.alertId !== alert.alertId);
      } else {
        return [...prev, alert];
      }
    });
  };

  return (
    <CustomModal
      open={open}
      title="Dismiss Related Alerts"
      onClose={onKeep}
      scroll
      additionalButtons={{
        after: [
          {
            title: "Dismiss",
            icon: "check-circle-outline",
            variant: "dark",
            onPress: () => onDismiss(checkedAlerts),
          },
        ],
      }}
    >
      <View style={classes.root}>
        {alerts.length === 0 ? (
          <Text style={classes.noneText}>No related alerts.</Text>
        ) : (
          <>
            <Text style={classes.text}>
              With this change, would you also like to dismiss the following:
            </Text>
            <ScrollView>
              {sortedAlerts.map((alert) => {
                const isChecked = checkedAlerts.some(
                  (candidateAlert) => candidateAlert.alertId === alert.alertId,
                );
                return (
                  <View key={alert.alertId} style={classes.row}>
                    <Text style={classes.text}>{alert.title}</Text>
                    <Checkbox
                      checked={isChecked}
                      onChange={() => handleCheck(alert)}
                    />
                  </View>
                );
              })}
            </ScrollView>
          </>
        )}
      </View>
    </CustomModal>
  );
}
